module.exports = __webpack_public_path__ + "static/divider2-a4debe6b8e29fbdf865a5ada83490740.svg";